;(function($){

    $(document).ready(function() {
 
        var $html = $('html'),
            $body = $('body'),
            $window = $(window),
            nTimeoutId = 0,
            nTimeoutDelay = 500,
            bHasTouch = $html.hasClass('touch'),
            bMobExperience = $html.hasClass('mobile-experience'),
            sMaxWidthCSS = '80%',
            sMaxHeightCSS = '80%',
            oDefaults = {};


        function fModalConfirm(){

                $('#cboxClose').on('hover', function(e){
                    
                   $('#cboxClose').unbind('click');
                   $('#cboxClose').on('click', function(ev){
                        ev.stopPropagation(); 
                        $('#cboxClose').addClass('cboxClose').removeAttr('id');                 
                        $.colorbox({scrolling: false, inline:true, maxWidth:'380px', height:'280px', href:"#confirm-dialog"});
                   });
                   
                });

        }

        function fPauseAudio(){

            var $nav = $('#main-header').find("nav");
            var $audio = $nav.find("audio");
            var $volume = $nav.find('.nav-volume');         
            bAudio = $audio.length > 0;

            if (Modernizr.audio && bAudio){
                if($volume.hasClass("vol-on")){
                    $audio[0].pause();
                    $volume.removeClass("vol-on");
                }  
            }
        }

        var fPreventDefault = function(e) {
            e.preventDefault();
        };

        var fResizeHandler = function(){

            window.clearTimeout(fResizeHandler);

            fResizeHandler = window.setTimeout(function(){

                 $.colorbox.load(true);

            }, nTimeoutDelay)

        };

        var fOpenCallback = function() {

            fPauseAudio();

            if (bHasTouch) {
               // $body.on('touchstart.colorboxInit', '#cboxOverlay', fPreventDefault);
            }

            $window.on('resize.colorboxInit', fResizeHandler);

        };

        var fClosedCallback = function() {

            if (bHasTouch) {
               // $body.off('touchstart.colorboxInit', '#cboxOverlay', fPreventDefault);
            }

            $window.off('resize.colorboxInit', fResizeHandler);

        };
        /* Initialise */

        /* Set new defaults */
        $.extend($.colorbox.settings, {
            fixed: false,
            onOpen: fOpenCallback,
            onClosed: fClosedCallback,
            photo: true,
            scalePhotos: true,
            maxWidth: sMaxWidthCSS
        });

        // $("a[rel*='lightbox']").colorbox(); 

        if (!bMobExperience) {
            $(".lb_image").colorbox();
        }
        
        if (!bHasTouch) {

            $(".lb_youtube").colorbox({
                photo: false,
                iframe: true,
                innerWidth: sMaxWidthCSS,
                innerHeight: sMaxWidthCSS,
                maxWidth: false,
                maxHeight: false
            });

        }

        $(".lb_inline").colorbox({
            scrolling: false,
            inline: true
        });

        $(".lb_inline_modal").colorbox({
            scrolling: false,
            inline: true,
            width: '700px',
            height: '810px',
            maxWidth:'700px',
            maxHeight:'810px',
            overlayClose: true,
            onComplete: fModalConfirm
        });

        $(".lb_inline_noscroll").colorbox({
            inline: true,
            scrolling: false
        });

        $(".lb_inline_modal_signup").colorbox({
            scrolling: false,
            inline: true,
            width: '760px',
            height: '700px',
            maxWidth:'760px',
            maxHeight:'700px',
            overlayClose: true,
            onComplete: fModalConfirm
        });
        
        // If an image id sent, activate that colorbox item
        
        function getUrlParam(name) {
            return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.search)||[,""])[1].replace(/\+/g, '%20'))||null;
        }

        var lightboxId = getUrlParam("lb"); //e.g http://0.0.0.0:4573/game_record.html?lb=creed

        if(lightboxId) {            
            $("#"+ lightboxId).click();
        }

    });


})(jQuery);
